import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import { DossierIntervention } from 'app/models/dossier_intervention.model';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import { DossierInterventionService } from 'app/services/dossier_intervention.service';
import { UserService } from 'app/services/user.service';
import { UserService as CoreUserService } from 'app/core/user/user.service';
import { User } from 'app/models/user.model';
import { User as CoreUser } from 'app/core/user/user.types';
import {get} from 'lodash-es';
import {FicheIntervention} from '../../../models/ficheIntervention.model';
import {FicheInterventionService} from '../../../services/fiche-intervention.service';
import { FuseConfirmationService } from '@fuse/services/confirmation';

@Component({
  selector: 'app-dossier-intervention',
  templateUrl: './dossier-intervention-id.component.html'
})
export class DossierInterventionIdComponent implements OnInit {
    idDossierIntervention: number;
    currentFicheIntervention: FicheIntervention;
    currentDossierIntervention: DossierIntervention = new DossierIntervention();
    errors: string[] = [];
    success: boolean = false;
    error: boolean = false;
    users: User[] = [];
    tabIndex: number = 0;
    user: CoreUser;
    unsavedChanges: boolean = false;
    dossierInterventionForm: FormGroup;

    tabs = [
        { label: "Dossier d'intervention" },
        { label: "Créance" },
        { label: "Photos" },
        { label: "Interventions" },
        { label: "Heures travaillées" },
        { label: "Rapport psychométrique" }
    ];

    private routeSub: Subscription;
    private isDossierLoaded: boolean = false;
    private isFicheLoaded: boolean = false;

    constructor(

        private dossierInterventionService: DossierInterventionService,
        private ficheInterventionService: FicheInterventionService,
        private userService: UserService,
        private cd: ChangeDetectorRef,
        private route: ActivatedRoute,
        private fuseConfirmationService: FuseConfirmationService,
        private router: Router,
        private _userService: CoreUserService) { }

    get f(): { [p: string]: AbstractControl } | undefined
    {
        return this.dossierInterventionForm?.controls;
    }

    get isLoaded(): boolean{
        return this.isDossierLoaded && this.isFicheLoaded;
    }
    ngOnInit(): void {
        this._userService.user$
            .subscribe((user: CoreUser) => {
                this.user = user;
            });

        this.route.params.subscribe((params) => {
            this.idDossierIntervention = params['idDossierIntervention'];
            this.getDossierIntervention(this.idDossierIntervention);
        });

        this.tabIndex = get(this.route, 'snapshot.fragment', 0);

        this.getUsers();
        const usersId = [];
        if(this.currentDossierIntervention.users !== undefined && this.currentDossierIntervention.users.length > 0){
            for(const user of this.currentDossierIntervention.users){
                usersId.push(user.id);
            }
        }

        this.onTabClick(0);
    }

    getDossierIntervention(id: number): void{
        this.dossierInterventionService.getDossierIntervention(id).subscribe((dossierIntervention) => {
            this.currentDossierIntervention = dossierIntervention;
            this.isDossierLoaded = true;
        });

        this.ficheInterventionService.getFichesInterventions(id).subscribe((ficheInterventions) => {
            this.currentFicheIntervention = ficheInterventions.pop();
            this.isFicheLoaded = true;
        });
    }



    getUsers(): void {
        this.userService.getUsers().subscribe((users) => {
            this.users = users;
        });
    }

    setForm(): void{
        if(this.currentDossierIntervention != null){
            const usersId = [];
            if(
                this.currentDossierIntervention.users !== undefined
                && this.currentDossierIntervention.users.length > 0
            ){
                for(const user of this.currentDossierIntervention.users){
                    usersId.push(user.id);
                }
            }
            this.dossierInterventionForm.patchValue({
                no_dossier: this.currentDossierIntervention.no_dossier,
                compagnie_assurance: this.currentDossierIntervention.compagnie_assurance,
                nom_assure: this.currentDossierIntervention.nom_assure,
                date_perte: this.currentDossierIntervention.date_perte,
                adresse_propriete_endommagee: this.currentDossierIntervention.adresse_propriete_endommagee,
                personne_contact: this.currentDossierIntervention.personne_contact,
                commentaires: this.currentDossierIntervention.commentaires,
                date_rendez_vous: this.currentDossierIntervention.date_rendez_vous,
                users_id: usersId,
            });
        }
    }



    onFormSubmit(): void{
        this.error = false;
        this.success = false;
        this.dossierInterventionForm.markAllAsTouched();

        if(this.dossierInterventionForm.valid){
            const dossierIntervention = new DossierIntervention(this.dossierInterventionForm.value);
            this.dossierInterventionService.update(dossierIntervention, this.currentDossierIntervention.id).subscribe(
                (response) => {
                    this.routeSub = this.route.params.subscribe((params) => {
                        if(params['id'] != null){
                            this.router.navigate(
                                ['/dossiersInterventions'],
                                { relativeTo: this.route, queryParams: { } }
                            );
                        }
                    });
                    this.success = true;
                    this.unsavedChanges = false;
                },(error) => {
                    this.error = true;
                }
            );
        }
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }

    hasUnsavedChanges(): Observable<boolean> {
        if (this.unsavedChanges) {
            return new Observable<boolean>(observer => {
            this.fuseConfirmationService.open().afterClosed().subscribe(result => {
                if (result === 'confirmed') {
                observer.next(true);  // Allow navigation
                } else {
                observer.next(false);  // Prevent navigation
                }
                observer.complete();
            });
            });
        }
    }

    refresh($event: any): void {

    }

    onTabClick(index: number): void {
        if (this.unsavedChanges) {
            const confirmation = this.fuseConfirmationService.open({
                title: 'Confirmation',
                message: 'Êtes-vous certain de vouloir quitter la page? Vous avez des changements qui n\'ont pas été sauvegardés.',
                actions: {
                    confirm: { label: 'Confirmer' },
                    cancel: { label: 'Annuler' }
                },
            });

            confirmation.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    this.updateTabIndex(index);
                    this.unsavedChanges = false;
                }
            });
        } else {
            this.updateTabIndex(index);
        }
    }

    private updateTabIndex(index: number): void {
        this.tabIndex = index;
        this.router.navigate([], {
            relativeTo: this.route,
            fragment: this.tabIndex.toString(),
            replaceUrl: true,
        });
        this.cd.detectChanges();
    }
}
